import React, { Suspense, lazy } from "react";
import Hero from "../components/Hero";
import SkillsTicker from "../components/SkillsTicker";
import "../pages_css/Home.css";

const FeaturedProjects = lazy(() => import("../components/Featured_projects"));
const ContactSection = lazy(() => import("../components/Contact_section"));

function Home() {
  return (
    <>
      <Hero />
      <SkillsTicker />
      <section className="home-section">
        <div className="home-content">
          <Suspense fallback={<div className="section-loading">Loading projects...</div>}>
            <FeaturedProjects />
          </Suspense>
          <Suspense fallback={<div className="section-loading">Loading contact...</div>}>
            <ContactSection />
          </Suspense>

        </div>
      </section>
    </>
  );
}

export default Home;